import { useEffect, useState } from 'react';
import { useTranslation } from '@klv/hooks/useTranslation';
import { GatsbyImage } from 'gatsby-plugin-image';
import ReactPlayer from 'react-player';
import Buttons from '@klv/molecules/buttons';
import Eyebrow from '@klv/atoms/eyebrow';

import * as s from './styles/videoHero.module.css';

import { designSystemColors } from '@klv/shared/styles/colors';

import type { IVideoHero } from './types';

export const VideoHero = ({
  backgroundColor,
  buttons,
  playVideoOnlyOnScroll,
  poster,
  videoUrl,
  ...props
}: IVideoHero) => {
  const { t } = useTranslation();

  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    let isScrolling = setTimeout(() => { }, 0);

    const detectScroll = () => {

      window.clearTimeout(isScrolling);
      setIsPlaying(true);

      isScrolling = setTimeout(() => {
        setIsPlaying(false);
      }, 66);
    };
    addEventListener('scroll', detectScroll);

    return () => removeEventListener('scroll', detectScroll);
  }, []);

  const playerProps = {
    url: videoUrl,
    loop: true,
    controls: false,
    playing: playVideoOnlyOnScroll ? isPlaying : true,
    width: '100%',
    height: '100%',
    volume: 0,
    muted: true,
    className: s.reactPlayer,
  };

  const posterImage = poster?.gatsbyImage || poster?.localFile?.childImageSharp?.gatsbyImageData;

  return (
    <div className={s.videoHero} style={{ backgroundColor: designSystemColors[backgroundColor as keyof typeof designSystemColors] }}>
      <div className={s.videoContainer} {...props}>
        <ReactPlayer
          config={{ vimeo: { playerOptions:{ texttrack: t('langCodes_recaptchaLanguage') === 'en' ? '' : t('langCodes_recaptchaLanguage') } } } }  
          style={{ objectFit: 'fill' }}
          {...playerProps}
        />
        <div className={s.contentContainer}>
          <div className={s.textContainer}>
            <div className={s.eyebrow}>
              <Eyebrow textColor="white" content={props.eyebrow} />
            </div>
            <h1 className={s.headerText}>
              {props.header}
            </h1>
            <div className={s.subText}>
              {props.paragraph}
            </div>
          </div>
          <div className={s.buttonContainer}>
            <Buttons
              className={s.buttons}
              buttons={buttons}
              buttonColor='light'
              variants={['primary', 'ghost']}
            />
          </div>
        </div>
        {posterImage ? <GatsbyImage alt="" className={s.poster} image={posterImage} /> :
          <img className={s.poster} src="https://t3.ftcdn.net/jpg/04/63/51/28/360_F_463512856_GEk2IrQkYatpRVR9YDhiZgRY2z00Zet3.jpg" />}
        <div className={s.dimLayer}></div>
      </div>
    </div>
  );
};
